// Importación de estilos y librerías de terceros
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.css';

// Importación de FontAwesome para iconos
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons';
library.add(faMagnifyingGlass);

// Importación de Vue y el sistema de rutas
import { createApp } from 'vue';
import App from './App.vue';
import router from './router/router';

import Toast from 'vue-toastification';
import 'vue-toastification/dist/index.css';

// Importación de Vuex (gestión de estado)
import store from './store';

// Configuración de internacionalización (i18n)
import i18n from './i18n';

// Importación de vue-flag-icon para mostrar banderas de países
import FlagIcon from 'vue-flag-icon';
import axios from 'axios';

import { getHostContext } from './services/hostContext';
import { resolveApiBaseUrl } from './services/apiConfig';
import { secureStorage } from './services/secureStorage';

function normalizePublicHashRoute() {
	const { pathname, search, hash, origin } = window.location;

	const publicRoutePatterns = [
		/^\/forgot-password(?:\/[^/?#]+)?$/,
		/^\/timer-code\/[^/?#]+$/,
	];

	if (!publicRoutePatterns.some(pattern => pattern.test(pathname))) {
		return;
	}

	const expectedHash = `#${pathname}${search}`;
	if (hash === expectedHash) {
		return;
	}

	window.location.replace(`${origin}/#${pathname}${search}`);
}

normalizePublicHashRoute();

// Importación y configuración de Axios (HTTP Client)
axios.defaults.withCredentials = true;
const apiBaseUrl = resolveApiBaseUrl();
axios.defaults.baseURL = apiBaseUrl; // Configuración de la API base
// axios.defaults.baseURL = 'https://www.slackline-tjs.com/api';
// axios.defaults.baseURL = 'https://staging.slackline-tjs.com/api';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Content-Type'] = 'application/json';
axios.defaults.headers.common['Accept'] = 'application/json';

axios.interceptors.request.use(config => {
	const token = secureStorage.getItem('setIn');
	if (token && !config.headers.Authorization) {
		config.headers.Authorization = `Bearer ${token}`;
	}
	return config;
});

// Creación de la aplicación Vue
const app = createApp(App);

// Contexto de host disponible globalmente
const hostContext = getHostContext();
app.config.globalProperties.$hostContext = hostContext;
app.provide('hostContext', hostContext);

// Registrar el componente FontAwesome globalmente
app.component('font-awesome-icon', FontAwesomeIcon);

// Configuración de plugins en la aplicación
app.use(router);   // Configuración del router
app.use(i18n);     // Configuración de la internacionalización
app.use(FlagIcon); // Configuración del plugin de banderas
app.use(store);    // Configuración del store Vuex
app.use(Toast);
// Proveer Axios globalmente (mejor alternativa a `globalProperties`)
// app.provide("$axios", axios);
// Agrega Axios a la instancia de Vue
app.config.globalProperties.$axios = axios;
// Montar la aplicación en el elemento con id `#app`
app.mount('#app');
